var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Loader from '../shared/Loader.vue';
import Choices from 'choices.js';
const service = namespace('Service');
let ReportsList = class ReportsList extends Vue {
    constructor() {
        super(...arguments);
        this.searchParam = '';
        this.loading = true;
        // docType: string = 'report';
        this.data = [];
        this.filter1Options = [];
        // filter2Options: any[] = [];
        this.select1 = null;
        // select2: Choices | null = null;
        // filter1: string = '';
        // filter2: string = '';
        this.selectProps = {
            searchEnabled: false,
            shouldSort: false,
            placeholder: true,
            placeholderValue: '',
            itemSelectText: '',
        };
    }
    created() {
        let args = {
            siteId: window.cibbic.siteId,
        };
        this.getDocuments(args);
    }
    mounted() {
        this.select1 = new Choices('#filter1', this.selectProps);
        this.setSelectOptions();
        this.getSearchParamValue();
        // this.select2 = new Choices('#filter2', this.selectProps);
    }
    getSearchParamValue() {
        this.searchParam = new URLSearchParams(window.location.search).get('reportType');
    }
    onfilterChange(docId) {
        if (docId) {
            let tmp = [];
            this.documentsData.forEach(element => {
                if (element.docType[0].id == docId) {
                    tmp.push(element);
                }
            });
            this.data = tmp;
        }
        else {
            this.data = this.documentsData;
        }
        history.pushState({}, "", "?reportType=" + docId);
        this.getSearchParamValue();
    }
    setSelectOptions() {
        var _a, _b;
        this.getSearchParamValue();
        if (this.searchParam) {
            let notSelectedItems = this.docTypes.filter(element => element.id != this.searchParam);
            let selectedItem = this.docTypes.find(element => element.id == this.searchParam);
            notSelectedItems.forEach(element => {
                this.filter1Options.push({
                    value: element.id,
                    label: element.title
                });
            });
            this.filter1Options.unshift({ value: this.searchParam, label: selectedItem.title, selected: true });
            this.filter1Options.unshift({ value: '', label: this.labels.all, selected: false });
            (_a = this.select1) === null || _a === void 0 ? void 0 : _a.setChoices(this.filter1Options, 'value', 'label', true);
        }
        else {
            this.docTypes.forEach(element => {
                this.filter1Options.push({
                    value: element.id,
                    label: element.title
                });
            });
            this.filter1Options.unshift({ value: '', label: this.labels.all, selected: true });
            (_b = this.select1) === null || _b === void 0 ? void 0 : _b.setChoices(this.filter1Options, 'value', 'label', true);
        }
    }
    // onFilter1Changed(evt) {
    //   this.filter1 = evt.detail.value
    //   this.filterType(this.filter1);
    //   if (this.filter1) {
    //     this.setFilter2Options();
    //   }
    // }
    // onFilter2Changed(evt) {
    //   this.filter2 = evt.detail.value;
    //   this.filterDate(this.filter2);
    // }
    // filterType(value: string) {
    //   this.switchDocTypeData(false);
    //   if (value === '') return;
    //   let tmp: any[] = [];
    //   this.data.forEach(element => {
    //     if (element[this.docType + 'Type'][0].id === value) {
    //       tmp.push(element);
    //     }
    //   });
    //   this.data = tmp;
    // }
    // filterDate(value: string) {
    //   this.filterType(this.filter1);
    //   if (value === '') return;
    //   let tmp: any[] = [];
    //   this.data.forEach(element => {
    //     if (element[this.docType + 'Year'] === value) {
    //       tmp.push(element);
    //     }
    //   });
    //   this.data = tmp;
    // }
    // setDocType(value: string) {
    //   this.docType = value;
    //   this.switchDocTypeData();
    // }
    // setFilter1Options() {
    //   this.filter1Options = [];
    //   this.filter2Options = [];
    //   this.filter2 = '';
    //   this.filter1 = '';
    //   this.data.forEach(element => {
    //     let exist = this.filter1Options.find((i) => {
    //       return i.value === element[this.docType + 'Type'][0].id
    //     });
    //     if (!exist) {
    //       this.filter1Options.push({
    //         value: element[this.docType + 'Type'][0].id,
    //         label: element[this.docType + 'Type'][0].title
    //       });
    //     }
    //   });
    //   this.filter1Options.sort((a, b) => {
    //     return a.label.localeCompare(b.label);
    //   });
    //   this.filter1Options.unshift({value: '', label: this.labels.all, selected: true});
    //   this.select1?.setChoices(this.filter1Options, 'value', 'label', true);
    // }
    // setFilter2Options() {
    //   this.filter2Options = [];
    //   const years = this.data.map(e => e[this.docType + 'Year'].trim()).filter((x, i, a) => a.indexOf(x) == i);
    //   years.forEach(year => {
    //     this.filter2Options.push({
    //       value: year,
    //       label: this.translate(year)
    //     });
    //   });
    //   this.filter2Options.sort((a, b) => {
    //     return b.label.localeCompare(a.label);
    //   });
    //   this.filter2Options.unshift({value: '', label: this.labels.all, selected: true});
    //   this.select2?.setChoices(this.filter2Options, 'value', 'label', true);
    // }
    // switchDocTypeData(setOptions: boolean = true) {
    //   if (this.docType == 'report') {
    //     this.data = this.documentsData.reports;
    //   } else {
    //     this.data = this.documentsData.transparency;
    //   }
    //   if (setOptions) {
    //     this.setFilter1Options();
    //   }
    // }
    // translate(value: string) {
    //   if (window.cibbic.siteId == 2) {
    //     return value.replace(' to ', ' à ');
    //   }
    //   return value;
    // }
    onDocumentsDataChanged(value) {
        this.data = this.documentsData;
        this.loading = false;
        if (this.searchParam) {
            this.onfilterChange(this.searchParam);
        }
        // this.filter1Options = [];
        // this.filter2Options = [];
        // this.switchDocTypeData();
    }
};
__decorate([
    Prop({ type: Array })
], ReportsList.prototype, "docTypes", void 0);
__decorate([
    Prop({ type: Object })
], ReportsList.prototype, "labels", void 0);
__decorate([
    service.State
], ReportsList.prototype, "documentsData", void 0);
__decorate([
    service.Action
], ReportsList.prototype, "getDocuments", void 0);
__decorate([
    Watch('documentsData')
], ReportsList.prototype, "onDocumentsDataChanged", null);
ReportsList = __decorate([
    Component({
        components: {
            Loader
        }
    })
], ReportsList);
export default ReportsList;
